export default __webpack_public_path__ + "static/media/grita.d45043e0.png";